export default class MobileMenu {
  constructor() {
    const menuButton = $('.hamburger-menu');
    const langMenu = $('.lang-button');
    const overlay =  $('.header--mobile__overlay');

    langMenu.on('click', () => {
      langMenu.find('.icon').toggleClass('active');
      $('.header--mobile__small-nav__menu').slideToggle();
    });

    menuButton.on('click', () => {
      menuButton.toggleClass('open');
      $('.header--mobile__main-nav__menu').toggleClass('open');
      $('.header--mobile__overlay').toggleClass('menu-open');
    })

   overlay.on('click', () => {
      if($('.header--mobile__main-nav__menu').hasClass('open')) {
        menuButton.removeClass('open');
        $('.header--mobile__main-nav__menu').removeClass('open');
        overlay.removeClass('menu-open');
      }
    })

    $(window).on('scroll', () => {
      this.makeNvabarSticky();
    });    

    $(window).on('resize', () => {
      this.makeNvabarSticky();
    });

    $(window).on('hashchange', () => {
      this.goToCurrentSection();
    });

    $(document).ready(() => {
      this.goToCurrentSection();
    })
  }

  goToCurrentSection() {
    const id = window.location.hash;
    if(id) this.scrollToSection(id);
  }

  scrollToSection(id) {
    let offset = 0;
    if(window.innerWidth < 992) {
      offset = $('.header--mobile__main-nav').outerHeight();
    } else {
      offset = $('.header__main-nav').outerHeight();
    }
    $(window).scrollTop($(`${id}`).offset().top - offset);
  }

  makeNvabarSticky() {
    const scrollPosition = $(window).scrollTop();
    let menuHeight;
    if($(window).width() > 992) {
      menuHeight = $('.header__main-nav').height();
      if (scrollPosition >= menuHeight + 10) 
      {
        $('.header__main-nav').css('position', 'fixed');
        $('main').css('margin-top', $('.header__main-nav').outerHeight());
      }
      else 
      {
        $('.header__main-nav').css('position', 'relative');
        $('main').css('margin-top', 0);
      }
    } else {
      menuHeight = $('.header--mobile__small-nav').height();
      if (scrollPosition >= menuHeight +10) { 
        $('.header--mobile__main-nav').css('position', 'fixed');
        $('main').css('margin-top', $('.header--mobile__main-nav').outerHeight());
        $('.header--mobile__main-nav__menu__list').height($(window).height() - menuHeight);
      }
      else {
        $('.header--mobile__main-nav').css('position', 'relative');
        $('main').css('margin-top', 0);
        $('.header--mobile__main-nav__menu__list').height($(window).height() - (menuHeight + 41));
      }
    }
  }

}


// WEBPACK FOOTER //
// ./scripts/components/menu.js